import { createSlice } from '@reduxjs/toolkit';
import { CreditApplicationMonitor } from '@dill/dill-shared';
import {
  createCreditApplicationMonitorExtraReducer,
  getCreditApplicationMonitorExtraReducer,
  getSupplierCreditApplicationsMonitorExtraReducer,
  updateCreditApplicationMonitorExtraReducer,
} from '../reducers/creditApplicationsMonitorReducers';

export interface CreditApplicationsMonitorInitialState {
  loadingList: string[];
  creditApplicationsMonitor: CreditApplicationMonitor[];
  creditApplicationMonitor: CreditApplicationMonitor | null;
}

const initialState: CreditApplicationsMonitorInitialState = {
  loadingList: [],
  creditApplicationsMonitor: [],
  creditApplicationMonitor: null,
};

export const creditApplicationsMonitorSlice = createSlice({
  name: 'creditApplicationsMonitor',
  initialState,
  reducers: {
    resetCreditApplicationsMonitorRootState: () => initialState,
  },
  extraReducers(builder) {
    createCreditApplicationMonitorExtraReducer(builder);
    getCreditApplicationMonitorExtraReducer(builder);
    getSupplierCreditApplicationsMonitorExtraReducer(builder);
    updateCreditApplicationMonitorExtraReducer(builder);
  },
});

export const { resetCreditApplicationsMonitorRootState } = creditApplicationsMonitorSlice.actions;
